import React from "react";

/**
 * How often a game in progress is re-read. Only the live game is polled — the
 * standings and the rest of a page are as good as when they loaded — so a page
 * left open costs a small request every half minute.
 */
export const LIVE_REFRESH_MS = 30_000;

interface LiveRefreshIndicatorProps {
  /** True while a refresh is in flight. */
  isRefreshing: boolean;
}

/**
 * Says that a live score is keeping itself up to date, and turns as each
 * refresh goes out.
 *
 * Without it a still clock reads as a page that has stopped listening rather
 * than as a game between periods, which is the more common of the two.
 */
export default function LiveRefreshIndicator({
  isRefreshing,
}: LiveRefreshIndicatorProps) {
  return (
    <span
      className="lp-live-refresh"
      title={`The score and clock refresh every ${
        LIVE_REFRESH_MS / 1000
      } seconds`}
    >
      <i
        className={`bi bi-arrow-repeat${
          isRefreshing ? " lp-live-refresh-spin" : ""
        }`}
        aria-hidden="true"
      />
      <span className="lp-live-refresh-interval" aria-hidden="true">
        {LIVE_REFRESH_MS / 1000}s
      </span>
      <span className="lp-visually-hidden">
        The score and clock refresh automatically
      </span>
    </span>
  );
}
